module.exports = __webpack_public_path__ + "img/info_icon.3d707b96.svg";